<template>
  <div class="EditTodoTemplate" :class="{ archived: todoTemplate.archived }">
    <iconToggle
      v-model="expanded"
      iconOff="static/icon/H2BOON-list-edit.png"
      iconOn="static/icon/H2BOON-list-open.png"
    />
    <iconToggle
      v-if="expanded"
      :value="todoTemplate.archived"
      @input="updateSimpleProperty('archived', $event)"
      iconOff="static/icon/H2BOON-list-missing.png"
      iconOn="static/icon/H2BOON-list-plus.png"
      class="right"
    />
    <h3>
      <inputField
        id="title"
        class="half"
        :label="expanded ? $t('Title') : ''"
        :value="todoTemplate.title"
        :readonly="todoTemplate.archived"
        @input="updateSimpleProperty('title', $event)"
      />
    </h3>
    <div class="items">
      <draggable @update="childMoved" handle=".glyphicon-move" v-model="todoTemplates">
        <template v-for="(todoTemplateItem, idx) in todoTemplates">
          <div v-if="expanded" :key="todoTemplateItem._id">
            <EditTodoTemplateItem :todoTemplate="todoTemplate" :index="idx" :todoTemplateItem="todoTemplateItem" />
          </div>
          <span
            class="item"
            v-if="!expanded && !todoTemplateItem.archived"
            :key="todoTemplateItem._id"
            :style="{ color: todoTemplateItem.colour }"
          >
            {{ todoTemplateItem.title + (idx < todoTemplates.length - 1 ? ',' : '') }}
          </span>
        </template>
      </draggable>
      <EditTodoTemplateItem
        ref="new"
        v-if="expanded"
        :todoTemplate="todoTemplate"
        :index="todoTemplates.length"
        :key="itemCount"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EditTodoTemplateItem from './EditTodoTemplateItem';
import inputField from '@/components/form/inputField';
import iconToggle from '@/components/iconToggle/iconToggle';
import draggable from 'vuedraggable';

export default {
  name: 'EditTodoTemplate',
  props: {
    todoTemplate: {},
  },
  data() {
    return {
      expanded: this.todoTemplate._rev && this.todoTemplate._rev.startsWith('1-'),
    };
  },
  methods: {
    ...mapActions(['saveTodoTemplateProperties', 'saveTodoTemplateItemProperties']),
    childMoved: function (e) {
      this.saveTodoTemplateItemProperties({
        updateTodoTemplate: this.todoTemplate,
        index: e.oldIndex,
        newIndex: e.newIndex,
      });
    },
    updateSimpleProperty: function (property, newValue) {
      if (this.todoTemplate[property] !== newValue) {
        var newTodoTemplateProperties = {};
        newTodoTemplateProperties[property] = newValue;
        this.saveTodoTemplateProperties({
          updateTodoTemplate: this.todoTemplate,
          newTodoTemplateProperties: newTodoTemplateProperties,
        });
      }
    },
  },
  computed: {
    ...mapGetters(['hasSimplePermissions']),
    todoTemplates: {
      get() {
        return this.todoTemplate.todoTemplates;
      },
      set(value) {},
    },
    itemCount: function () {
      return this.todoTemplates.length;
    },
  },
  watch: {
    itemCount: function () {
      this.$nextTick(() => {
        this.$refs['new'].focus();
      });
    },
  },
  components: {
    draggable,
    EditTodoTemplateItem,
    iconToggle,
    inputField,
  },
};
</script>

<style scoped>
.EditTodoTemplate {
  margin-bottom: 3em;
}

img.icon {
  width: 25px;
  margin-right: 5px;
}

.items {
  margin-left: 35px;
  margin-bottom: 15px;
}
.item {
  display: inline-block;
}

.right {
  float: right;
}

h3 {
  display: inline-block;
  width: 80%;
}
.archived h3 {
  text-decoration: line-through;
}
.sortable-chosen {
  border: 1px solid rgb(241, 249, 5);
  box-shadow: 0px 0px 42px -6px rgba(255, 247, 0, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/project/EditTodoTemplate.vue